/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects' // eslint-disable-line
import changeActualPasswordActions, {
    changeActualPasswordTypes,
} from '../../../redux/user/changeActualPassword'
import loginActions from '../../../redux/login'

import { Put } from '../../../serveur/axios'
import alertActions from '../../../redux/alert'

function* changeActualPasswordSagas({ response }) {
    try {
        const res = yield Put(`users/change_actual_password`, response)

        if (res.status === 200 || res.status === 201 || res.status === 202) {
            yield all([
                yield put(
                    changeActualPasswordActions.changeActualPasswordSuccess(res.data)
                ),
                // yield put(push('/demande/liste/en-cours')),
                yield put(
                    loginActions.loginSuccess({
                        User: res.data.data,
                        Token: localStorage.getItem('mfpeToken'),
                    })
                ),
                yield put(
                    alertActions.alertShow(true, {
                        onConfirm: false,
                        warning: false,
                        info: false,
                        error: false,
                        success: true,
                        message:
                            response.language === 'ar'
                                ? 'تم تغيير كلمة العبور الحالية'
                                : 'Votre mot de passe actuel à été changée',
                        title: response.language === 'ar' ? ' تم' : 'Succés',
                    })
                ),
            ])
        } else {
            yield put(changeActualPasswordActions.changeActualPasswordFailure(res))
        }
    } catch (error) {
        yield put(changeActualPasswordActions.changeActualPasswordFailure(error))
    }
}

export function* changeActualPasswordSaga() {
    yield takeLatest(
        changeActualPasswordTypes.CHANGE_ACTUAL_PASSWORD_REQUEST,
        changeActualPasswordSagas
    )
}
